import { v4 as uuidv4 } from 'uuid';

import { Login } from '../../../../vtex-apps/login/Login/default';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { DrawerCloseButton } from '../../../../vtex-apps/store-drawer/DrawerCloseButton/default';
import { ModalTrigger } from '../../../../vtex-apps/modal-layout/ModalTrigger/default';
import { ModalLayout } from '../../../../vtex-apps/modal-layout/ModalLayout/default';
import { SearchBar } from '../../../../vtex-apps/store-components/SearchBar/default';
import { ModalActionsClose } from '../../../../vtex-apps/modal-layout/ModalActions/default';
import { Logo } from '../../../../vtex-apps/store-components/Logo/default';

const HeaderMobile = () => {
	return {
		componentName: 'HeaderMobile',
		componentId: uuidv4(),
		componentGroup: 'HeaderMobile',
		props: {
			mzTitle: 'MZ | Header - Mobile',
		},
		childrenComponents: [
			{
				componentName: 'StickyLayout',
				componentId: uuidv4(),
				props: {
					blockClass: 'sticky-header-mobile-3',
					position: 'top',
					verticalSpacing: 0,
				},
				childrenComponents: [
					{
						componentName: 'FlexLayoutRow',
						componentId: uuidv4(),
						props: {
							colSizing: 'auto',
							blockClass: 'mz-header-3-mobile',
							fullWidth: true,
						},
						childrenComponents: [
							{
								componentName: 'Drawer',
								componentId: uuidv4(),
								props: {
									blockClass: 'mz-header-3-mobile',
									slideDirection: 'horizontal',
									isFullWidth: true,
								},
								blocks: [
									{
										componentName: 'DrawerHeader',
										componentId: uuidv4(),
										props: {
											blockClass: 'mz-header-3-mobile',
										},
										childrenComponents: [DrawerCloseButton()],
									},
								],
								childrenComponents: [
									{
										componentGroup: 'StoreMenuMobile',
										componentName: 'Menu',
										componentId: uuidv4(),
									},
									{
										componentName: 'FlexLayoutRow',
										componentId: uuidv4(),
										dragDirection: 'horizontal',
										draggableType: 'StickyLayout',
										droppableType: 'Container',
										props: {
											colSizing: 'auto',
											blockClass: 'mz-header-3-mobile__login-container',
											fullWidth: true,
											preserveLayoutOnMobile: true,
										},
										childrenComponents: [
											{
												componentName: 'FlexLayoutCol',
												componentId: uuidv4(),
												props: {
													fullWidth: true,
													blockClass: 'mz-header-3-mobile__login',
												},
												childrenComponents: [
													Login({
														iconLabel: 'Minha conta',
														blockClass: 'mz-header-3-mobile__login-text',
														accountOptionsButtonBehavior: 'link',
													}),
												],
											},
											{
												componentName: 'FlexLayoutCol',
												componentId: uuidv4(),
												props: {
													fullWidth: true,
													blockClass: 'mz-header-3-mobile__favoritos',
												},
												childrenComponents: [
													RichText({
														text: 'Meus **favoritos**',
														blockClass: 'mz-header-3-mobile__favoritos-text',
													}),
												],
											},
										],
									},
									{
										componentName: 'FlexLayoutRow',
										componentId: uuidv4(),
										dragDirection: 'horizontal',
										draggableType: 'StickyLayout',
										droppableType: 'Container',
										props: {
											colSizing: 'auto',
											blockClass: 'mz-header-3-mobile__links-container',
											fullWidth: true,
											preserveLayoutOnMobile: true,
										},
										childrenComponents: [
											{
												componentName: 'FlexLayoutCol',
												componentId: uuidv4(),
												props: {
													fullWidth: true,
													blockClass: 'mz-header-3-mobile__links-container',
												},
												childrenComponents: [
													RichText({
														text: '**Dúvidas?**',
														blockClass: 'mz-header-3-mobile__link',
													}),
													RichText({
														text: 'Fale com a gente por WhatsApp',
														blockClass: 'mz-header-3-mobile__link',
													}),
													RichText({
														text: 'Envie seu contato para a gente',
														blockClass: 'mz-header-3-mobile__link',
													}),
													RichText({
														text: 'Atendimento: de Segunda a Sexta-feira das 09:00 às 18:00 e Sábado das 08:00 às 13:00',
														blockClass: 'mz-header-3-mobile__link',
													}),
												],
											},
										],
									},
								],
							},
							Logo({
								height: 30,
								url: 'https://maeztra.com/wp-content/uploads/2020/09/logo_Prancheta-1.svg',
								href: '/',
								title: 'Logo',
								blockClass: 'mz-header-3-mobile',
							}),

							ModalTrigger(
								{
									blockClass: 'mz-header-3-mobile-modal__trigger',
								},
								[
									RichText({
										text: 'Search',
										blockClass: 'mz-header-3-mobile-search',
									}),
									ModalLayout(
										{
											blockClass: 'mz-header-3-mobile',
										},
										[
											SearchBar({
												placeholder: 'O que procura?',
												blockClass: 'mz-header-3-mobile',
											}),
											ModalActionsClose({
												blockClass: 'mz-header-3-mobile',
											}),
										],
									),
								],
							),
							RichText({
								text: 'Favoritos',
								blockClass: 'mz-header-3-mobile__favoritos',
							}),
							{
								componentGroup: 'MinicartGroup',
								componentName: 'MinicartGroup',
								componentId: uuidv4(),
							},
						],
					},
				],
			},
			// VisibilityLayout({ visible: true, mzTitle: "Modal de cookies" }, [{ componentName: "CookieModal" }])
		],
	};
};

export default HeaderMobile;
